import { RoleType } from '@entities/profile/model/types'
import { normalizeDate } from '@shared/lib/date'

export class ProfileModel {
  constructor(
    public userName: string | null,
    public role: RoleType,
    public subscriptionEndDate: string | Date,
    public subDays: number | null
  ) {}

  public getSubscriptionDate(): Date {
    return new Date(this.subscriptionEndDate)
  }

  public getNormalizeDate(t: (key: string) => string): string {
    return normalizeDate(t, new Date(this.subscriptionEndDate))
  }

  public hasAccess(): boolean {
    if (!this.subDays) return false
    return this.subDays > 0
  }
}
